import apiClient from '../apiClient';

export interface Notification {
  id: string;
  user_id: string;
  type: string;
  title: string;
  message: string;
  link?: string;
  is_read: boolean;
  priority?: string;
  data?: any;
  created_at: string;
  read_at?: string;
}

export interface NotificationCountResponse {
  count: number;
}

export interface NotificationsResponse {
  notifications: Notification[];
  total: number;
  page: number;
  limit: number;
}

class NotificationService {
  /**
   * Get unread notification count
   */
  async getUnreadCount(): Promise<NotificationCountResponse> {
    const response = await apiClient.get<{ success: boolean; data: NotificationCountResponse }>(
      '/notifications/unread/count'
    );
    return response.data;
  }

  /**
   * Get notifications
   */
  async getNotifications(page = 1, limit = 20, onlyUnread = false): Promise<NotificationsResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (onlyUnread) {
      params.append('unread', 'true');
    }

    const response = await apiClient.get<{ success: boolean; data: NotificationsResponse }>(
      `/notifications?${params.toString()}`
    );
    return response.data;
  }

  /**
   * Mark notification as read
   */
  async markAsRead(notificationId: string): Promise<void> {
    await apiClient.put(`/notifications/${notificationId}/read`);
  }

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<void> {
    await apiClient.put('/notifications/read-all');
  }

  /**
   * Delete notification
   */
  async deleteNotification(notificationId: string): Promise<void> {
    await apiClient.delete(`/notifications/${notificationId}`);
  }
}

export const notificationService = new NotificationService();
